<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>

      <v-toolbar-title class="pageTitle">
        Rechnungen ansehen
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper ordersContent virtual-padding" ref="contentWrapper">
        <v-virtual-scroll class="order_virtual-scroll" style="padding-bottom: 160px;" item-height="260"
                          v-if="!isLoading && invoices.length" :items="invoices" bench="1" ref="vScrollComp">
          <template v-slot:default="{index, item}">
            <v-row  class="articleCardRow" :key="index">
              <v-col cols="12" class="articleCardCol"
                                  >
                <v-card
                  class="articleCard"
                  elevation="0"
                  style="padding-bottom: 20px;"
                >
                  <v-list-item>
                    <v-container>
                      <v-row class="orderCard">
                        <v-col cols="12">
                          <b>Bestellnummer: </b>
                          <span>{{ item.invoiceRaw.OrderNo }}</span>
                        </v-col>

                        <v-col cols="12">
                          <b>Rechnungsdatum: </b>
                          <span>{{ item.invoiceRaw.PostingDate | parseDate }}</span>
                        </v-col>

                        <v-col cols="12">
                          <b>Rechnungsnummer: </b>
                          <span>{{ item.invoiceRaw.DocumentNo }}</span>
                        </v-col>

                        <v-col cols="12">
                          <b>Gesamtsumme: </b>
                          <span>{{ item.invoice.GrossAmount | parsePrice2Digits }} € brutto</span>
                        </v-col>

                      </v-row>
                    </v-container>
                  </v-list-item>
                </v-card>
                <v-btn class="tour-nav-forward-btn" style="margin-left: 10px;" v-if="item.hasMissingItems" @click="goToMissingItems(item, index)">
                  Fehlzettel anzeigen
                  <v-icon>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
                <v-btn class="tour-nav-forward-btn" @click="goToInvoice(item, index)">
                  Zur Rechnung
                  <v-icon>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-virtual-scroll>
      <div v-if="!isLoading && !invoices.length" style="height: 100%; text-align: center;">
        <span>Es wurden keine Rechnungen gefunden.</span>
      </div>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import axios from "axios";
const { XMLParser } = require("fast-xml-parser");

export default {
  name: "Invoices",
  data() {
    return {
      isLoading: true,
      invoices: [

      ]
    }
  },
  methods: {
    ...mapMutations('invoices', ['setInvoiceData']),
    goBack() {
      this.$router.go(-1)
    },
    goToInvoice(item, index) {
      localStorage.setItem('invoiceIndex', index)
      this.setInvoiceData(item)
      this.$router.push({ path: `invoices/${item.invoice.id}` })
    },
    goToMissingItems(item, index) {
      localStorage.setItem('invoiceIndex', index)
      this.setInvoiceData(item)
      this.$router.push({ path: `invoices/missingItems/${item.invoice.id}` })
    }
  },
  async mounted() {
    /*
    const rawInvoices = ['<Document><DocumentType>Invoice</DocumentType><DocumentNo>RG240002877</DocumentNo><PostingDate>03.09.2024</PostingDate><DueDate>03.09.2024</DueDate><AccountType>Customer</AccountType><AccountNo>12220</AccountNo><OrderNo>AU240003159</OrderNo><Description>Beschreibung</Description><PaymentTerms>Rechnung wird per SEPA beglichen</PaymentTerms><InvoiceDiscountPercent>0</InvoiceDiscountPercent><NetAmount>708,06</NetAmount><VATAmount>67,00</VATAmount><GrossAmount>775,06</GrossAmount><VATDetails><VATDetail><VATPercent>19</VATPercent><BaseAmount>145,29</BaseAmount><VATAmount>27,61</VATAmount><GrossAmount>172,90</GrossAmount></VATDetail><VATDetail><VATPercent>7</VATPercent><BaseAmount>562,77</BaseAmount><VATAmount>39,39</VATAmount><GrossAmount>602,16</GrossAmount></VATDetail></VATDetails><Lines><Line><LineNo>10000</LineNo><PositionNo>2</PositionNo><Type>Item</Type><No>52231</No><Description>40/250g ja! Deutsche Markenbutter</Description><Description2>Beschreibung 2</Description2><Quantity>1</Quantity><UnitOfMeasure>Ktn</UnitOfMeasure><BaseUnitOfMeasure>Stück</BaseUnitOfMeasure><QtyPerUnitOfMeasure>40</QtyPerUnitOfMeasure><QuantityBase>40</QuantityBase><SalesPrice>72,76</SalesPrice><SalesPriceBase>1,819</SalesPriceBase><RRP>1,99</RRP><LineDiscountPercent>0</LineDiscountPercent><NetAmount>72,76</NetAmount><VATPercent>7</VATPercent></Line><Line><LineNo>36000</LineNo><PositionNo>36</PositionNo><Type>Item</Type><No>01328</No><Description>12/11 PET Rhön Sprudel MiWa naturell</Description><Description2>Beschreibung 2</Description2><Quantity>1</Quantity><UnitOfMeasure>Ka.</UnitOfMeasure><BaseUnitOfMeasure>Ka</BaseUnitOfMeasure><QtyPerUnitOfMeasure>1</QtyPerUnitOfMeasure><QuantityBase>1</QuantityBase><SalesPrice>6,084</SalesPrice><RRP>7,99</RRP><SalesPriceBase>6,084</SalesPriceBase><LineDiscountPercent>19</LineDiscountPercent><NetAmount>6,08</NetAmount><VATPercent>19</VATPercent></Line></Lines><Empties><EmptiesItem><Quantity>1</Quantity><UnitOfMeasure>Ka.</UnitOfMeasure><SalesPrice>1,50</SalesPrice><NetAmount>1,50</NetAmount><VATPercent>19</VATPercent></EmptiesItem><EmptiesItem><Quantity>12</Quantity><UnitOfMeasure>FI.</UnitOfMeasure><SalesPrice>0,15</SalesPrice><NetAmount>1,80</NetAmount><VATPercent>19</VATPercent></EmptiesItem></Empties><MissingItems><MissingItem><LineNo>S0000</LineNo><PositionNo>12</PositionNo><Type>Item</Type><No>52248</No><Description>20/250g Frankenland Frucht Buttermilch Getränk</Description><Description2>Beschreibung 2</Description2><Ordered><Quantity>1</Quantity><UnitOfMeasure>Ka.</UnitOfMeasure><BaseUnitOfMeasure>Bch</BaseUnitOfMeasure><QtyPerUnitOfMeasure>20</QtyPerUnitOfMeasure><QuantityBase>20</QuantityBase></Ordered><Shipped><Quantity>0</Quantity><UnitOfMeasure>Ka.</UnitOfMeasure><BaseUnitOfMeasure>Bch</BaseUnitOfMeasure><QtyPerUnitOfMeasure>20</QtyPerUnitOfMeasure><QuantityBase>0</QuantityBase></Shipped><Missing><Quantity>1</Quantity><UnitOfMeasure>Ka.</UnitOfMeasure><BaseUnitOfMeasure>Bch</BaseUnitOfMeasure><QtyPerUnitOfMeasure>20</QtyPerUnitOfMeasure><QuantityBase>20</QuantityBase></Missing></MissingItem><MissingItem><LineNo>80000</LineNo><PositionNo>47</PositionNo><Type>Item</Type><No>09753</No><Description>15/40g Knorr Salatkrönung Gartenkräuter 5er</Description><Description2>Beschreibung 2</Description2><Ordered><Quantity>15</Quantity><UnitOfMeasure>St.</UnitOfMeasure><BaseUnitOfMeasure>St</BaseUnitOfMeasure><QtyPerUnitOfMeasure>1</QtyPerUnitOfMeasure><QuantityBase>10</QuantityBase></Ordered><Shipped><Quantity>5</Quantity><UnitOfMeasure>St.</UnitOfMeasure><BaseUnitOfMeasure>St</BaseUnitOfMeasure><QtyPerUnitOfMeasure>1</QtyPerUnitOfMeasure><QuantityBase>5</QuantityBase></Shipped><Missing><Quantity>10</Quantity><UnitOfMeasure>St.</UnitOfMeasure><BaseUnitOfMeasure>St</BaseUnitOfMeasure><QtyPerUnitOfMeasure>1</QtyPerUnitOfMeasure><QuantityBase>10</QuantityBase></Missing></MissingItem></MissingItems></Document>']
    */

    const result = await axios.get('api/invoices/all')

    const parser = new XMLParser();

    result.data.forEach(invoice => {
      let jObj = parser.parse(invoice.invoiceRaw);

      const invoiceRaw = jObj.Document
      if(invoiceRaw.MissingItems?.MissingItem && !Array.isArray(invoiceRaw.MissingItems?.MissingItem)) {
        invoiceRaw.MissingItems.MissingItem = [invoiceRaw.MissingItems.MissingItem]
      }
      const obj = { invoiceRaw: invoiceRaw, hasMissingItems: invoiceRaw.MissingItems?.MissingItem?.length, invoice: invoice }
      this.invoices.push(obj)
    })
    this.isLoading = false
    setTimeout(() => {
      if(localStorage.getItem('invoiceIndex')) {
        const idxStr = localStorage.getItem('invoiceIndex')
        if (idxStr !== null) {
          const idx = parseInt(idxStr, 10) || 0
          this.$refs.contentWrapper.scrollTop = idx * 260
          localStorage.removeItem('invoiceIndex')
        }
      }
    }, 10)
  }
}
</script>

<style scoped>

</style>
